export default function FabricIcon({ fabricId, imageUrl, isActive, onClick }) {
    return(
        isActive
            ? <img className="pointer color-item active" src={imageUrl} onClick={() => onClick(fabricId)} />
            : <img className="pointer color-item" src={imageUrl} onClick={() => onClick(fabricId)} />
    )
}